import { LOGOS } from '../../data/customerLogos';

/* The real customer logos, taken from the live landing page — the previous
   version of this strip used invented brands (Meridian, NovaCart, HELIXPAY…),
   which is a claim the company can't back.

   Revolving marquee, same behaviour as the live site: the row is rendered twice
   and translated by exactly -50%, so the second copy is under the cursor at the
   moment the animation restarts and the loop is seamless. Pauses on hover. */

export default function Trusted() {
  return (
    <section className="trusted" id="s-trusted">
      <div className="container">
        <div className="trusted-row">
          <span className="trusted-label">TEAMS ALREADY RUNNING ON TEAMGRID</span>

          <div className="tmarquee">
            <div className="tmarquee-track">
              {/* rendered twice — the duplicate is what makes the loop seamless */}
              {[...LOGOS, ...LOGOS].map((logo, i) => (
                <span className="tlogo" key={`${logo.alt}-${i}`}>
                  <img src={logo.src} alt={i < LOGOS.length ? logo.alt : ''} aria-hidden={i >= LOGOS.length} loading="lazy" />
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
